import React, { Component } from "react";
import "./NodeManager.css";
import "./OrganizationDashboard.css";
import axios from "axios";
import "react-notifications-component/dist/theme.css";
import "animate.css";
import { UserAccessTable } from "./UserAccessTable";

class AccessDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      loading: false,
      loaded_users: false,
      potentialusers: {},
      selectedusers: [],
    };
  }
  componentDidMount() {
    this.getUserInfo();
  }

  getHeaders = () => {
    return {
      Authorization: `Token ${this.props.token}`,
    };
  };

  setUsers = (users) => {
    this.setState({ selectedusers: users });
  };

  user_is_selected = () => {
    return this.state.selectedusers.length > 0;
  }

  approve_request = (approve, key) => {
    let selectedusers = this.state.selectedusers;
    let baseUrl = this.props.baseUrl;
    let headers = this.getHeaders();
    let instance = this;
    if(selectedusers.length > 0){
      this.setState({ loading: true });
    }
    selectedusers.forEach(function (item, index) {
      let approved_args = {};
      approved_args["uuid"] = item.uuid;
      approved_args["key"] = key;
      approved_args["approved_request"] = approve;
      axios
        .post(
          baseUrl + "/api/api/potentialuser/approve_access/",
          approved_args,
          {
            headers: headers,
          }
        )
        .then((res) => {
          axios
            .get(baseUrl + "/api/api/potentialuser/", {
              headers: headers,
            })
            .then((res) => {
              instance.setState({ potentialusers: res.data });
              this.setState({ loading: false });
            })
            .catch((err) => {
              instance.setState({ loading: false });
            });
        })
        .catch((err) => {
          instance.setState({ loading: false });
        });
    });
  };

  getUserInfo = () => {
    axios
      .get(this.props.baseUrl + "/api/api/users/me/", {
        headers: this.getHeaders(),
      })
      .then((res) => {
        this.setState({ userInfo: res.data });

        axios
          .get(this.props.baseUrl + "/api/api/potentialuser/", {
            headers: this.getHeaders(),
          })
          .then((res) => {
            this.setState({ potentialusers: res.data });
            this.setState({ loaded_users: true });
          })
          .catch((err) => {});
      })
      .catch((err) => {});
  };

  render() {
    return (
      <>
        {this.state.loaded_users ? (
          <div className="organization">
            <div className="organization_title">
              <h1>{"Beta Access Requests"}</h1>
            </div>
            <div className="action_selection">
              <div className="action_buttons">
                {this.state.loading ? <b>Processing...</b> : null }
                <button
                  disabled={this.state.loading || !this.user_is_selected()}
                  onClick={() => this.approve_request("true", "")}
                  className="action_button2"
                >
                  Approve
                </button>
                <button
                  disabled={this.state.loading || !this.user_is_selected()}
                  onClick={() => this.approve_request("true", "IPNSIG2022")}
                  className="action_button2"
                >
                  Approve (IPNSIG)
                </button>
                <button
                  disabled={this.state.loading || !this.user_is_selected()}
                  onClick={() => this.approve_request("false", "")}
                  className="action_button3"
                >
                  Reject
                </button>
              </div>
            </div>
            <br />
            <div className="info_table">
              <UserAccessTable
                users={this.state.potentialusers}
                setSelection={this.setUsers}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default AccessDashboard;
